export enum IntegrationService {
  GOOGLE_DRIVE = 'GOOGLE_DRIVE',
  MICROSOFT_SHAREPOINT = 'MICROSOFT_SHAREPOINT',
  MICROSOFT_ONEDRIVE = 'MICROSOFT_ONEDRIVE',
}
